// constants/GatePassConstants.ts - Updated for 4-step workflow

export const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://gatepass-api-1753632520.azurewebsites.net/api';

// Step definitions - UPDATED for 4-step workflow
export const STEPS = [
  { id: 1, title: 'Basic Information', description: 'Personal and request details' },
  { id: 2, title: 'Gates & Personnel', description: 'Choose access points and select personnel' },
  { id: 3, title: 'Approval & Details', description: 'Choose approvers, reviewers, and additional information' },
  { id: 4, title: 'Review & Submit', description: 'Final review and submission' }
];

// File upload constraints
export const FILE_CONSTRAINTS = {
  MAX_SIZE_MB: 10,
  ACCEPTED_EXTENSIONS: ['.pdf', '.doc', '.docx', '.xls', '.xlsx', '.jpg', '.jpeg', '.png', '.gif', '.txt'],
  ACCEPTED_MIME_TYPES: [
    'application/pdf',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/vnd.ms-excel',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'image/jpeg',
    'image/jpg',
    'image/png',
    'image/gif',
    'text/plain'
  ]
};

// Auto-save configuration
export const AUTO_SAVE_INTERVAL_MS = 60000; // 60 seconds

// Request type options
export const REQUEST_TYPES = [
  { value: 'new', label: 'New' },
  { value: 'supplementary', label: 'Supplementary' }
] as const;

// Pass type options
export const PASS_TYPES = [
  { value: 'single_visit', label: 'Single Visit' },
  { value: 'short_term', label: 'Short Term' },
  { value: 'long_term', label: 'Long Term' }
] as const;

// Fallback regions (used when API fails)
export const FALLBACK_REGIONS = [
  { regionId: 1, regionName: 'North America', regionCode: 'NA', isActive: true },
  { regionId: 2, regionName: 'Europe', regionCode: 'EU', isActive: true },
  { regionId: 4, regionName: 'Latin America', regionCode: 'LATAM', isActive: true },
  { regionId: 5, regionName: 'Middle East & Africa', regionCode: 'MEA', isActive: true }
];

// Validation messages - UPDATED for 4-step workflow
export const VALIDATION_MESSAGES = {
  REQUIRED_FIELD: 'This field is required',
  INVALID_EMAIL: 'Please enter a valid email address',
  DATE_RANGE_INVALID: 'End date must be on or after start date',
  NO_GATES_SELECTED: 'Please select at least one gate',
  NO_PERSONNEL_SELECTED: 'Please select at least one personnel',
  NO_APPROVERS_SELECTED: 'Please select at least one approver',
  NO_REGION_SELECTED: 'Please select a region',
  NO_CONSIGNMENT_DETAILS: 'Please provide consignment details',
  FILE_TOO_LARGE: `File size must be less than ${FILE_CONSTRAINTS.MAX_SIZE_MB}MB`,
  INVALID_FILE_TYPE: 'Invalid file type. Please select a supported file format',
  // Step-specific validation messages
  STEP1_INCOMPLETE: 'Please complete all required basic information fields',
  STEP2_INCOMPLETE: 'Please select both gates and personnel',
  STEP3_INCOMPLETE: 'Please select approvers and provide consignment details',
  STEP4_READY: 'All information provided - ready to submit'
};

// Status message types
export const STATUS_TYPES = {
  SUCCESS: 'success',
  ERROR: 'error',
  INFO: 'info'
} as const;

// Processing time estimates
export const PROCESSING_TIME = '2-3 business days';

// ADDED: Step validation requirements for the 4-step workflow
export const STEP_REQUIREMENTS = {
  STEP_1: ['name', 'email', 'regionId', 'requestType', 'passType'],
  STEP_2: ['selectedGates', 'selectedPersonnel'],
  STEP_3: ['approverSelection', 'consignmentDetails'],
  STEP_4: ['allPreviousSteps']
} as const;